import React, {useState} from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { SetTokenizeUser } from "store/dispatcher";
import stateMap from "store/stateMap";
import update from "immutability-helper";
import { popinfo } from "component/Fancybox/Fancybox";
import { RefreshAzureToken } from "component/LoginBox/LoginBox";
import api from "api";

const ComponentJointPool = connect(stateMap, { SetTokenizeUser}) (props => {
    const [jointPool, setJointPool] = useState(false);

    const ToggleJointPool = (e) => {
        if(!props.auth.user)
        {
            return;
        }
        
        setJointPool(!jointPool);

        api('/Config/PromoteSelf', 'post', {
            promoting : e.target.checked
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setJointPool(response.is_promoting);

                RefreshAzureToken(props.auth.user.Token3rd, props.auth.user.Token3rdExpires)
                        .then(() => {

                            props.SetTokenizeUser(
                                update(props.auth.user, {
                                    PromotingSelf : {
                                        $set : response.is_promoting
                                    }
                                })
                            );
                            
                        })
            })
            .catch(error => {
                popinfo('error', 'Joining Pool Talent', error);
            })

        
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return
        }

        setJointPool(props.auth.user.PromotingSelf);

    }, [props.auth.user])

    return (
        <label className="switch-button">
            <input 
                type="checkbox"
                checked={jointPool}
                onChange={ToggleJointPool}
            />
            <span className="slider round"></span>
        </label>
    )
});

export { ComponentJointPool }